import { loadStripe } from '@stripe/stripe-js';

// Load Stripe instance
// This will be initialized with the publishable key from environment variables
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '');

export { stripePromise };
